import { toJS } from 'mobx';
import * as Graphic from '@src/slide/infrastructure/module/independent/graphic';
import { SpecialShape } from '../../../../../infrastructure/module/dependent/shape-info/shape-base/specialGraphicConnectPoint';
import { IMultiModelFrameMap } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { IPointerInfo } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import has from 'lodash/has';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

/**
 * 针对当前图形的连接点能够连接的位置
 * @param elementModel
 * @param index
 * @param {IMultiModelFrameMap} toUpdateModelFrameMap 存储所有选中的图形待更新的frame
 * @returns {any|{x: *, y: *}}
 */
export default function connectorPointOfIndex(
    elementModel: IElementBaseModel,
    index: number,
    toUpdateModelFrameMap?: IMultiModelFrameMap,
) {
    let controlValues: any[] = [];
    if (has(elementModel.props.style, 'controlValues')) {
        controlValues = toJS((elementModel.props.style as any).controlValues);
    }
    // eslint-disable-next-line new-cap
    let frame = elementModel?.getFrame?.().getFrameInfo(!!elementModel.operationFrame);
    if (toUpdateModelFrameMap?.get(elementModel.key)) {
        frame = { ...frame, ...toUpdateModelFrameMap.get(elementModel.key) };
    }
    const relativePoint = elementModel.pathParser.getConnectionPoints(
        frame.width,
        frame.height,
        controlValues as any,
    )[index];
    let position: IPointerInfo = {
        x: relativePoint.x + frame.left,
        y: relativePoint.y + frame.top,
    };
    position = Graphic.getPointAfterFlipAndRotate(position, frame);
    position = elementModel.getFrame?.().pointOnSlide(position, true);
    const bgShape = (elementModel as IShapeModel)?.props.style.bgShape;
    if (bgShape && SpecialShape[bgShape]) {
        position.direction = getPointDirection(bgShape, frame, index);
    }
    return position;
}

export function getPointDirection(type, frame, index) {
    const originDirection = SpecialShape[type][index];
    if ((frame?.flipH && (originDirection % 2) === 1) || (frame?.flipV && (originDirection % 2) === 0)) {
        return (originDirection + 2) % 4;
    }
    return originDirection;
}
